import Navbar from './Navbar';
import ShowNews from './ShowNews';

const News = () => (
    <div className="inner-page">
        <Navbar />
        <main>
            <header className="inner-page-hero project-page-hero news-page-hero">
                <div className="container">
                    <h1>Real-Time News Feed</h1>
                    <p className="inner-page-intro">
                        I fetch live headlines from an external API (NewsData.io) and render them with reusable React components. Scroll down to check it out!
                    </p>
                </div>
            </header>
            <div className="container project-notes project-notes-top">
                <details>
                    <summary>How I built it</summary>
                    <p>
                        The page requests headlines from NewsData.io and maps the JSON response into reusable article cards. It handles loading and error states (such as network errors or API usage errors), optional images and summaries, and lets you refresh for more articles.
                    </p>
                </details>
                <details>
                    <summary>Challenges</summary>
                    <p>
                        I found taht the API can return incomplete article data, and its free tier has request limits (which I thankfully don't run into often). I handle missing images and descriptions, show a clear error if the request fails, and cancel the request if you leave the page.
                    </p>
                </details>
                <details>
                    <summary>What I’d improve next</summary>
                    <p>
                        I’d add search and categories (maybe using an AI model to scan article summaries?) and make pages for individual articles. 
                    </p>
                </details>
            </div>
            <section className="page-section news-page-section" aria-labelledby="news-results-heading">
                <div className="container">
                    <div className="section-heading-row">
                        <div>
                            <h2 id="news-results-heading">News Feed</h2>
                        </div>
                        <span className="news-feed-source">
                            <span aria-hidden="true"></span>
                            Powered by NewsData.io
                        </span>
                    </div>
                    <ShowNews />
                </div>
            </section>
        </main>
    </div>
);

export default News;
